<template>
	<EmptyLayout class="app-not-authorized-window">

		<template v-if="localStoreTokensIsRead">
			<div
				v-if="isLoadingAuthorizedUserData"
				class="d-flex fill-height"
			>
				<ao-logo-preloader/>
			</div>

			<AuthWindow
				v-else
				@login="onLogin"
				@register="onRegister"
			/>
		</template>

		<NotificationProvider />

	</EmptyLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue'

import EmptyLayout  from '@/layouts/EmptyLayout.vue'
import AuthWindow from '@/components/windows/AuthWindow.vue'
import NotificationProvider from '@/components/provides/NotificationProvider.vue'

/* Composables */
import useCurrentUser from '@/composables/data/useCurrentUser'

/* Stores */
import { useUserStore } from '@/stores/userStore'

import {
	clientStorageLocal,
	LOCAL_STORAGE_AUTH_ACCESS_TOKEN_KEY,
	LOCAL_STORAGE_AUTH_REFRESH_TOKEN_KEY,
} from '@ao/utils'

// defineEmits({
// 	userLoaded: null
// })

const userStore = useUserStore()

const {
	setAuthToken,
} = userStore

const {
	isLoadingAuthorizedUserData,
	getAuthorizedUserData,
} = useCurrentUser()

const localStoreTokensIsRead = ref(false)


const getAuthorizedUser = ({ authAccessToken, authRefreshToken }) => {
	return new Promise((resolve, reject) => {
		// FIXME: не нужно в стор сохранять токены, только в локал стор
		setAuthToken({
			access: authAccessToken,
			refresh: authRefreshToken
		})
			.then(() => {
				getAuthorizedUserData()
					.then(() => {
						resolve()
					})
					.catch(() => {
						reject()
					})
			})
	})
}

const onLogin = (tokens) => {
	// console.log('onLogin', tokens)
	getAuthorizedUser(tokens)
}

const onRegister = (tokens) => {
	// console.log('onRegister', tokens)
	getAuthorizedUser(tokens)
}

onMounted(() => {
	const authAccessToken = clientStorageLocal.get(LOCAL_STORAGE_AUTH_ACCESS_TOKEN_KEY)
	const authRefreshToken = clientStorageLocal.get(LOCAL_STORAGE_AUTH_REFRESH_TOKEN_KEY)
	localStoreTokensIsRead.value = true
	if (authAccessToken) {
		getAuthorizedUser({ authAccessToken, authRefreshToken })
	}
})
</script>
